
import { useEffect } from 'react';
import { useLanguage } from '@/context/LanguageContext';
import Navbar from '@/components/homepage/Navbar';
import Footer from '@/components/homepage/Footer';
import RadexHero from '@/components/homepage/radex/RadexHero';
import RadexAbout from '@/components/homepage/radex/RadexAbout';
import RadexFeatures from '@/components/homepage/radex/RadexFeatures';
import RadexPartnership from '@/components/homepage/radex/RadexPartnership';

const Radex = () => {
  const { t } = useLanguage();
  
  // Scroll to top on page load
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-gray-900">
      <Navbar />
      <main className="flex-grow">
        <RadexHero />
        <RadexAbout />
        <RadexPartnership />
        <RadexFeatures />
      </main>
      <Footer />
    </div>
  );
};

export default Radex;
